import { render, staticRenderFns } from "./GraficoXySegmentacao.vue?vue&type=template&id=94eb029e&"
import script from "./GraficoXySegmentacao.vue?vue&type=script&lang=js&"
export * from "./GraficoXySegmentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports